import {collectEnumValues} from '../../../../libs/shared/helpers/src/typescript/enumHelpers';
import type {EnumId, EnumParameter, Parameter, ParameterId, StringParameter} from '../commons/parameterModel';
import {AtomParamTypesEnum} from './expressionAtomModel';
import {getEnumName, getEnumTooltip, getParameterLabel} from './expressionLabels';

export function buildParameter(id: string, type: AtomParamTypesEnum, format?: string): Parameter {
  if (type === AtomParamTypesEnum.TEAMMATE_LIST) {
    return {
      id: id as ParameterId,
      title: getParameterLabel(id),
      public: true,
      type: 'array',
      items: {
        id: 'item' as ParameterId,
        title: 'Teammate',
        public: true,
        type: 'number',
        format: 'teammate',
      },
      minItems: 0,
      uniqueItems: true,
      additionalItems: false,
    };
  }

  return {
    id: id as ParameterId,
    title: getParameterLabel(id),
    public: true,
    type,
    format,
  } as Parameter;
}

export function buildEnumParameter(
  id: string,
  enumType: {[key: string]: string},
  defaultValue?: string,
): EnumParameter {
  const enumValues = collectEnumValues(enumType);

  return {
    id: id as ParameterId,
    title: id,
    public: true,
    enum: enumValues as ReadonlyArray<EnumId>,
    default: (defaultValue || enumValues[0]) as EnumId,
    enumTitles: enumValues.map(getEnumName),
    enumDescriptions: enumValues.map(getEnumTooltip),
  };
}

export interface StringTemplateOptions {
  canUsePreviousResult?: boolean;
  canUseRegex?: boolean;
}

export function buildStringTemplateParameter(
  id: string,
  options: StringTemplateOptions = {},
): StringParameter {
  return {
    id: id as ParameterId,
    title: getParameterLabel(id),
    public: true,
    type: AtomParamTypesEnum.STRING,
    canUsePreviousResult: options.canUsePreviousResult,
    canUseRegex: options.canUseRegex,
  };
}
